// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1JDk4","containerItemsCenter":"Skeleton_containerItemsCenter__2vHNy"};